export function extractProjects(payload) {
    return payload?.filteredView?.item ?? [];
}
export function projectIdOf(project) {
    return project.UUID || project.id || '';
}
export function projectStatusId(project) {
    return project.status?.id || 'ongoing';
}
/**
 * Statuses a unit-list action advertises, in backend order. The enum mixes
 * `{ id, name }` objects with a bare `''` entry (units without lead engagement),
 * and `listSoldUnits` pins a single object instead of an array — normalize all
 * shapes to `UnitStatusOption[]`. The popup renders one group per entry.
 */
export function unitStatusOptionsOf(action) {
    const raw = action.leadEngagementStatus;
    const entries = Array.isArray(raw) ? raw : raw != null ? [raw] : [];
    return entries.map((entry) => {
        if (typeof entry === 'string')
            return { id: entry, name: '' };
        const option = entry;
        return { id: option.id ?? '', name: option.name ?? '' };
    });
}
/**
 * True when the project has any 3DSK unit metrics. Used to decide whether to render
 * the Total Units / Available / Sold cards (they're meaningless on standalone projects).
 */
export function hasTDSKMetrics(project) {
    return (project.TDSKUnitsTotal != null ||
        project.TDSKUnitsAvailable != null ||
        project.TDSKUnitsSold != null);
}
